module.exports = __webpack_public_path__ + "img/si_logo.1a0f2e50.png";